import { useContext } from "react"
import { DesignEditorContext } from "~/contexts/DesignEditor"

function useDesignEditorContext() {
  const {
    editorType,
    setEditorType,
    displayPlayback,
    setDisplayPlayback,
    setDisplayPreview,
    displayPreview,
    setCropModalOpen,
    cropModalOpen,
    setExtrasModalOpen,
    extrasModalOpen,
    setErrorModalOpen,
    errorModalOpen,
    cropImage,
    setCropImage,
    currentScene,
    setCurrentScene,
    setScenes,
    scenes,
    maxTime,
    setMaxTime,
    contextMenuTimelineRequest,
    setContextMenuTimelineRequest,
    contextMenuSceneRequest,
    setContextMenuSceneRequest,
    currentDesign,
    setCurrentDesign,
    showDottedLine,
    setShowDottedLine,
  } = useContext(DesignEditorContext)
  return {
    editorType,
    setEditorType,
    displayPlayback,
    setDisplayPlayback,
    setDisplayPreview,
    displayPreview,
    setCropModalOpen,
    cropModalOpen,
    setExtrasModalOpen,
    setErrorModalOpen,
    errorModalOpen,
    extrasModalOpen,
    cropImage,
    setCropImage,
    currentScene,
    setCurrentScene,
    setScenes,
    scenes,
    maxTime,
    setMaxTime,
    contextMenuTimelineRequest,
    setContextMenuTimelineRequest,
    contextMenuSceneRequest,
    setContextMenuSceneRequest,
    currentDesign,
    setCurrentDesign,
    showDottedLine,
    setShowDottedLine,
  }
}

export default useDesignEditorContext
